export default "__VITE_ASSET__XFKTHhjy__"